import { API_PRODUCT } from '../config';
import { sendRequest } from '../send_request';
//
// Report one product
//
export const productReportRequest = async (uuid) => await sendRequest(API_PRODUCT.REPORT_PRODUCT_URL(uuid), 'POST', null);
